// Accent colours a visitor can pick. `dark` / `light` are the accent in each
// theme; `onDark` / `onLight` are the text colour on top of it (buttons).
// src/accents.css is generated from this list, and src/accents.test.js fails if
// the two drift apart or if any pair stops meeting WCAG AA contrast (4.5:1).
// "ember" is the default and lives in index.css.
export const DEFAULT_ACCENT = 'ember'

export const accents = [
    { id: 'ember', label: 'Ember', dark: '#e2603a', light: '#b43f1a', onDark: '#0d1013', onLight: '#ffffff' },
    { id: 'ocean', label: 'Ocean', dark: '#4aa3ff', light: '#0b5cad', onDark: '#0d1013', onLight: '#ffffff' },
    { id: 'forest', label: 'Forest', dark: '#3dbb85', light: '#1d7048', onDark: '#0d1013', onLight: '#ffffff' },
    { id: 'violet', label: 'Violet', dark: '#a78bfa', light: '#6d3fd1', onDark: '#0d1013', onLight: '#ffffff' },
    { id: 'rose', label: 'Rose', dark: '#f06292', light: '#b4235a', onDark: '#0d1013', onLight: '#ffffff' },
    { id: 'gold', label: 'Gold', dark: '#e0a526', light: '#8a5a00', onDark: '#0d1013', onLight: '#ffffff' },
]
